// @ts-strict-ignore
import getConfig from 'next/config'

/**
 * Get environment variable from process.env or Next.js runtime config
 * @param envName - Environment variable name
 * @param fallback - Fallback value if environment variable is not found
 * @returns Environment variable value or fallback
 */
export const getEnv = (envName: string, fallback: string = null): string => {
  if (!envName) {
    return fallback
  }

  const config = getConfig()
  const publicRuntimeConfig = config?.publicRuntimeConfig

  // Handle both server and client side
  if (typeof window !== 'undefined') {
    return process?.env?.[envName] ?? publicRuntimeConfig?.[envName] ?? fallback
  } else {
    return process?.env?.[envName] ?? publicRuntimeConfig?.[envName] ?? fallback
  }
}
